import {Component} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslocoDirective} from '@jsverse/transloco';
import {environment} from '@environments/environment';
import {RouterLink} from '@angular/router';
import {RouteGenerator} from '@core/route-generator';
import {UI_ROUTES} from '@core/ui.routes';

@Component({
  selector: 'app-public-terms-dashboard',
  imports: [
    ReactiveFormsModule,
    TranslocoDirective,
    RouterLink
  ],
  templateUrl: './terms-dashboard.component.html',
  styleUrl: './terms-dashboard.component.scss'
})
export class TermsDashboardComponent {
  public readonly domain = environment.domain;
  public readonly appName = environment.appName;

  public readonly routes = {
    publishTerms: RouteGenerator.abs(UI_ROUTES.public.terms.publish),
    privacy: RouteGenerator.abs(UI_ROUTES.public.terms.privacy)
  };
}
